@import (reference) '~ss-ui-client/src/constants/spacing.module.less';

.header {
  justify-content: space-between;
  align-items: center;
  min-height: 32px;
}

.description {
  color: var(--grey-600);
  margin-bottom: @space-16;
}

.info-banner {
  margin-top: @space-16;
}
